import React, { Component } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";

class Header extends Component {
  render() {
    return (
      <Navbar
        style={{ backgroundColor: "#3f51b5", minHeight: "66.5px" }}
        variant="dark"
        expand="lg"
      >
        <Navbar.Brand href="https://www.tdtchannels.com">
          <img
            src={`${process.env.PUBLIC_URL}/logo_200.png`}
            height="38"
            className="d-inline-block align-top"
            style={{ marginTop: "-8px" }}
            alt="TDTChannels logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse>
          <Nav className="mr-auto" activeKey={window.location.pathname}>
            <Nav.Link href="/television">TELEVISIÓN</Nav.Link>
            <Nav.Link href="/radio">RADIO</Nav.Link>
          </Nav>
        </Navbar.Collapse>
        <Navbar.Collapse className="justify-content-end">
          <Nav className="mr-sm-2">
            <Nav.Link
              onClick={this.props.toggleDarkMode}
              style={{ marginRight: "10px", fontSize: "18px" }}
            >
              {this.props.darkMode ? "☀️" : "🌙"}
            </Nav.Link>
            <Nav.Link
              href="https://www.tdtchannels.com/aviso-legal/"
              target="_blank"
            >
              LEGAL
            </Nav.Link>
            <Nav.Link
              href="https://www.tdtchannels.com/politica-privacidad/"
              target="_blank"
            >
              POLITICA DE PRIVACIDAD
            </Nav.Link>
            <Nav.Link
              href="https://www.tdtchannels.com/contacto/"
              target="_blank"
              style={{ marginRight: "15px" }}
            >
              CONTACTO
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Header;
